export const staticSlug = {
  wolf: "wolf",
  cove: "cove",
  "sub zero": "sub-zero",
  subzero: "sub-zero",
  // "luxury appliances": "luxury-appliances",
  "top deals": "top-deals",
  "top deal": "top-deals",
  "deal" : "top-deals",
  "deals": "top-deals",
  "open box appliances": "open-box-appliances",
  "open box": "open-box-appliances",
  rebate: "rebates",
  rebates: "rebates",
  "next day delivery": "next-day-delivery",
  "next day": "next-day-delivery",
  "amazon alexa":
    "browse-by-feature/amazon-alexa-appliances?fieldIds=105&fieldValueIds=22272",
  "google home":
    "browse-by-feature/google-home-appliances?fieldIds=108&fieldValueIds=22266",
  "remote control":
    "browse-by-feature/remote-control?fieldIds=110&fieldValueIds=22261",
  packages: "kitchen-packages",
  package: "kitchen-packages",
  outlet: "outlet",
  // luxury: "luxury-appliances",
  bodewell: "bodewell",
};
